export const TEXT_BUTTON_CREATE = '作成';
export const TEXT_BUTTON_UPDATE = '更新';
export const TEXT_BUTTON_SEND = '送信';
export const TEXT_BUTTON_BACKWARD = '前へ戻る';
export const TEXT_BUTTON_BACK = '戻る';
export const TEXT_BUTTON_LOGIN = 'ログイン';

// Create User Form And Profile
export const TEXT_USER_NAME = 'ユーザー名';
export const TEXT_LOGIN_ID = 'ユーザーID';
export const TEXT_PASSWORD = 'パスワード';
export const TEXT_ACCOUNT_TYPE = '権限';
export const TEXT_CONTACT = '通知用メールアドレス';
export const TEXT_PHONE = '連絡先';
export const TEXT_TWO_FACTOR_AUTHENTICATION = '2段階認証';
export const TEXT_DESCRIPTION = '備考';
export const TEXT_CURRENT_PASSWORD = '現在のパスワード';
export const TEXT_NEW_PASSWORD = '新しいパスワード';
export const TEXT_CONFIRM_PASSWORD = 'パスワード(確認用)';
export const TEXT_CONFIRM_NEW_PASSWORD = '新しいパスワード(確認用)';
export const TEXT_DOWNLOAD_HISTORY = '履歴ダウンロード';

// Login And Forgot Password Form
export const TEXT_FORGOT_PASSWORD_LINK = 'パスワードを忘れた方はこちら';
export const TEXT_FORGOT_PASSWORD_INSTRUCTION = 'ユーザー登録で使用したメールアドレスを入力してください。 パスワード再設定のメールを送信します。';
export const TEXT_FORGOT_PASSWORD_INPUT_CODE = 'メールを送信しました。メール本文に記載されている認証コードを入力し、新しいパスワードを設定してください。';
// Error
export const TEXT_ERROR_NAME_REQUIRED = 'Name is required!';
export const TEXT_ERROR_PASSWORD_REQUIRED = 'Password is required';
export const TEXT_ERROR_PASSWORD_INVALID = 'Password must have at least 8 characters, contain letter and number';
export const TEXT_ERROR_PASSWORD_NOT_MATCH = 'パスワードが一致していません。';
export const TEXT_ERROR_CONFIRM_PASSWORD_REQUIRED = 'パスワード(確認用)を設定していません。';
export const TEXT_ERROR_EMAIL_REQUIRED = 'Email is required!';
export const TEXT_ERROR_NULL = 'を設定していません。';
export const TEXT_ERROR_EMAIL_INVALID = 'Email is invalid!';
export const TEXT_ERROR_EMAIL_EXIST = '既に存在しているユーザーIDです。';
export const TEXT_ERROR_USER_NOT_CONFIRMED = 'User is not confirmed';
export const TEXT_ERROR_INCORRECT_PASSWORD = 'ユーザーIDまたはパスワードが正しくありません。';
export const TEXT_ERROR_INCORRECT_TOTP = '認証コードに誤りがあります。';
export const TEXT_ERROR_SENSOR_ALREADY_EXISTED = '既に登録されているセンサ（ELTRES ID）のため新規作成できません。';
// Dialog Message
export const DIALOG_MESSAGE_CONFIRM_DELETE_USER = "ユーザーを削除してもよろしいですか？";
export const DIALOG_MESSAGE_CONFIRM_DELETE_GROUP = "センサグループを削除してもよろしいですか？";
export const DIALOG_MESSAGE_CONFIRM_DELETE_NOTIFICATION = "お知らせを削除してもよろしいですか?";
export const DIALOG_MESSAGE_CONFIRM_DELETE_SENSOR = "センサを削除してもよろしいですか？";
export const DIALOG_MESSAGE_CONFIRM_SEND_MESSAGE = "メールを送信してもよろしいですか？";
export const DIALOG_MESSAGE_CREATED_UDER_SUCCESSFULLY = "ユーザーを正常に作成しました。";
export const DIALOG_MESSAGE_CREATED_GROUP_SUCCESSFULLY = "グループを正常に作成しました。";
export const DIALOG_MESSAGE_CREATED_SENSOR_SUCCESSFULLY = "センサを正常に作成しました。";
export const DIALOG_MESSAGE_UPDATED_UDER_SUCCESSFULLY = "ユーザーを正常に更新しました。";
export const DIALOG_MESSAGE_UPDATED_GROUP_SUCCESSFULLY = "グループを正常に更新しました。";
export const DIALOG_MESSAGE_UPDATED_SENSOR_SUCCESSFULLY = "センサを正常に更新しました。";
export const DIALOG_MESSAGE_DELETED_UDER_SUCCESSFULLY = "ユーザーを正常に削除しました。";
export const DIALOG_MESSAGE_DELETED_GROUP_SUCCESSFULLY = "グループを正常に削除しました。";
export const DIALOG_MESSAGE_DELETED_SENSOR_SUCCESSFULLY = "センサを正常に削除しました。";
export const DIALOG_MESSAGE_CHANGED_PASSWORD_SUCCESSFULLY = "パスワードを正常に変更しました。";
export const DIALOG_MESSAGE_SENT_MESSAGE_SUCCESSFULLY = "メールを正常に送信しました。";
export const DIALOG_MESSAGE_UPDATED_GENERAL_SETTING_SUCCESSFULLY = "一般設定を正常に更新しました。";
export const DIALOG_MESSAGE_UPLOAD_FILE_SUCCESSFULLY = "過去の登録時の画像アップロードに成功しました。"
export const DIALOG_MESSAGE_DELETE_CAMERA_IMAGE_FILE_SUCCESSFULLY = "最近の様子画像が正常に削除されました。";
export const DIALOG_MESSAGE_DELETE_CAMERA_PAST_FLOOD_FILE_SUCCESSFULLY = "過去の登録時画像が正常に削除されました。";
export const DIALOG_MESSAGE_CREATED_NOTIFICATION_SUCCESSFULLY = "お知らせを作成しました。";
export const DIALOG_MESSAGE_UPDATED_NOTIFICATION_SUCCESSFULLY = "お知らせを更新しました。";

// Dialog Error
export const DIALOG_ERROR_GENERAL_ERROR_MESSAGE = 'エラーが発生しました。やり直してください。';
export const DIALOG_ERROR_INVALID_CONFIRM_PASSWORD = "パスワードが一致していません。"
export const DIALOG_ERROR_INVALID_SCAN_TIME = "センサ受信間隔は不正です。"
export const DIALOG_ERROR_INVALID_CONFIRM_TIME = "異常検知時間は不正です。"
export const DIALOG_ERROR_INVALID_LAT = "緯度は不正です。"
export const DIALOG_ERROR_INVALID_LNG = "経度は不正です。"
export const DIALOG_ERROR_CONFIRM_TIME_LESS_THAN_SCAN_TIME = "異常検知時間はセンサ受信間隔より短いです。"
export const DIALOG_ERROR_INVALID_STATUS_TO_SEND_MAIL = "センサ情報が取得できていないため、メールを送信できません。"
export const DIALOG_ERROR_USE_SHORT_KEYWORD = "パスワードは8桁以上で設定してください。"
export const DIALOG_ERROR_USE_UPPERCASE_ELTRES_ID = "ELTRES IDの英字は小文字で入力してください。";
export const DIALOG_ERROR_DOWNLOAD_MORE_THAN_A_YEAR_OF_HISTORY = "1年以内の期間を指定してください。";
export const DIALOG_ERROR_INVALID_GRAPH_WATER_LEVEL = "グラフ表示の水位値は不正です。";
export const DIALOG_ERROR_INVALID_GRAPH_GATE_OPENING_LEVEL = "グラフ表示の水門開度値は不正です。";
// Left Menu
export const TEXT_SENSOR_MAP = 'マップ';
export const TEXT_SENSOR_LIST = '機器一覧';
export const TEXT_MANAGEMENT_SETTING = '管理設定';
export const TEXT_SENSOR_MANAGEMENT = '機器管理';
export const TEXT_USER_MANAGEMENT = 'ユーザー管理';
export const TEXT_MASTER_MANAGEMENT = 'マスタ管理';

// Properties
export const TEXT_NAME = '名称';
export const TEXT_GROUP_ID = 'グループID';
export const TEXT_ELTRES_ID = 'ELTRES ID';
export const TEXT_GROUP_NAME = 'グループ名';
export const TEXT_SENSOR_TYPE = 'センサ区分';
export const TEXT_REGISTERED_DATETIME = '登録日時';
export const TEXT_REGISTERED_DATE = '登録日';
export const TEXT_DATA_RECEIVED_DATETIME = 'データ取得日時';
export const TEXT_LATITUDE = '緯度';
export const TEXT_LONGITUDE = '経度';
export const TEXT_ZOOM_RATE = 'ズーム率';
export const TEXT_MANAGEMENT_ID = '管理番号';
export const TEXT_STATUS = 'ステータス';
export const TEXT_MESSAGE = 'メッセージ';
export const TEXT_LOCATION = '設置場所';
export const TEXT_UPDATED_DATE = '更新日';
export const TEXT_MESSAGE_GROUP = 'メッセージグループ';
export const TEXT_VALUE = '値';
export const TEXT_FLOOD_GATE_OPENING_LEVEL = '水門開度';
export const TEXT_INNER_WATER_LEVEL = '川裏水位';
export const TEXT_OUTER_WATER_LEVEL = '川表水位';
export const TEXT_POWER_VOLTAGE = '電源電圧';
export const TEXT_SENSOR_FLOOD = '冠水センサ';
export const TEXT_SENSOR_FLOOD_GATE = '水門センサ';
export const TEXT_SENSOR_CAMERA = 'カメラ';
export const TEXT_SENSOR_GENERAL = '汎用センサ';
export const TEXT_FLOOD_GATE_OPENING_PARAM = '水門開度パラメータ';
export const TEXT_FLOOD_GATE_OPENING_UNIT = '水門開度単位';
export const TEXT_FLOOD_GATE_OPENING_LEVEL_DISPLAY = '水門開度表示';
export const TEXT_INNER_WATER_PARAM = '川裏水位パラメータ';
export const TEXT_OUTTER_WATER_PARAM = '川表水位パラメータ';
export const TEXT_ABNORMAL_THRESHOLD = '異常判断閾値';
export const TEXT_OPENNING_THRESHOLD = '水門開度閾値';
export const TEXT_INNER_WATER_THRESHOLD = '川裏水位閾値';
export const TEXT_OUTER_WATER_THRESHOLD = '川表水位閾値';
export const TEXT_STATUS_DETAIL = 'ステータス詳細';
export const TEXT_MAX_WATER_LEVEL = '水位上限';
export const TEXT_MIN_WATER_LEVEL = '水位下限';
export const TEXT_MAX_OPENING_LEVEL = '水門開度上限';
export const TEXT_MIN_OPENING_LEVEL = '水門開度下限';
export const TEXT_TYPE_CAMERA = 'カメラ区分'
export const TEXT_SWAP_IMAGE_CAMERA = '左右画像の入替'
export const TEXT_TYPE_DISPLAY_CAMERA = 'マップ・機器一覧画面'
export const TEXT_CAMERA_FEATURE = 'カメラ機能'
export const TEXT_IP_ADDRESS = 'IPアドレス'
export const TEXT_USERNAME = 'ユーザーID'
export const TEXT_IMAGE_ACQUISITION_INTERVAL = '画像取得間隔(秒)'
export const TEXT_ZOOM_IMAGE_FEATURE = '拡大図表示'
export const TEXT_ZOOM_IMAGE_RATE = '拡大率'
export const TEXT_ZOOM_CENTER_COORDINATE_X = '拡大図の中心x座標(%)'
export const TEXT_ZOOM_CENTER_COORDINATE_Y = '拡大図の中心y座標(%)'
export const TEXT_SD_CARD_RECORDING = 'SDカード録画閲覧'
export const TEXT_TRAFFIC_VOLUME_FEATURE = '交通量カウント機能'
export const TEXT_IMAGE_ANALYSIS_FEATURE = '画像解析機能'
export const TEXT_IMAGE_ANALYSIS_EXCUTION = '画像解析実行期間'
export const TEXT_IMAGE_ANALYSIS_WEATHER_ACQUITION_INTERVAL = '天気情報取得間隔(分)'
export const TEXT_IMAGE_ANALYSIS_SYSTEM_PROMPT = 'システムプロンプト'
export const TEXT_IMAGE_ANALYSIS_USER_PROMPT = 'ユーザープロンプト'
export const TEXT_STORAGE_IMAGE_FEATURE = '画像保存機能'
export const TEXT_STORAGE_IMAGE_INTERVAL = '画像保存間隔(分)'
export const TEXT_STORAGE_IMAGE_PERIOD = '画像保存期間(日)'

// Page Login
export const TEXT_SAVE_LOGIN = 'ログイン状態を保持する';
export const TEXT_BACK = '前へ戻る';
export const TEXT_SEND = '送信';

// Page Profile
export const TEXT_PROFILE = 'プロフィール';
export const TEXT_CHANGE_PASSWORD = 'パスワード変更';
export const TEXT_CANCEL = 'キャンセル';

// Page User Management
export const TEXT_CREATE_USER = 'ユーザー作成';
export const TEXT_UPDATE_USER = 'ユーザー更新';
export const TEXT_RESET_PASSWORD = 'パスワードリセット';
export const TEXT_CREATE_NEW = '新規作成';
// Page Sensor Management
export const TEXT_CREATE_SENSOR = '機器作成';
export const TEXT_UPDATE_SENSOR = '機器更新';
export const TEXT_SENSOR_DETAIL = 'センサ詳細';

// Page Master Management
export const TEXT_MESSAGE_MANAGEMENT = 'メッセージ設定';
export const TEXT_NOTIFICATION_MANAGEMENT = 'お知らせ';

// User
export const TEXT_ROLE_USER = '一般';
export const TEXT_ROLE_MANAGER = '管理者';
export const TEXT_ROLE_ADMIN = 'マスター管理';